import Util from '../../Common/Util';
export default class Relation {
    constructor() {
    }
    initialize(){
        InitPgT();

        $('.phone-book').on('click', function(){
            const from = $(this).attr('data-value');
            $j.Ui.BS.open({
                target: '$j.F.ModalPhone',
                data: {
                    $p: { from, why: '연락처' },
                    onApply: ($r) => {
                        $('#sp_number').val(Util.phoneNumber($r['hp']));
                    },
                },
            });
        });
    }
}